export const topbar = (state = {action1: null, action2: null, actionBig: null}, action) => {
    switch (action.type) {
        case 'TOPBAR_ACTIONS_RELOAD':
            return action.context;
        default:
            return state
    }
};
